"use client";

import { useTranslations } from "next-intl";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ROOM_BILL_POLICIES } from "@/generated/contracts";
import { ROOM_BILL_UTILITIES } from "./roomBillUtilities";
import { setRoomBillCap, setRoomBillPolicy, type RoomBill, type RoomBillPolicy } from "./roomBills";
type Props = {
  value: RoomBill[];
  onChange: (value: RoomBill[]) => void;
};
export function RoomBillsEditor({
  value,
  onChange
}: Props) {
  const t = useTranslations("modules.properties.roomBills");
  const tUtility = useTranslations("modules.portfolio.paymentTypes");
  return <div className="flex flex-col gap-3 p-1" data-testid="room-bills-editor" data-sentry-component="RoomBillsEditor" data-sentry-source-file="RoomBillsEditor.tsx">
      {ROOM_BILL_UTILITIES.map(({
      paymentType,
      icon: Icon,
      labelKey
    }) => {
      const bill = value.find(b => b.paymentType === paymentType);
      const label = tUtility(labelKey);
      return <div key={paymentType} className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <span className="flex items-center gap-2 sm:w-32 text-sm font-medium text-foreground">
              <Icon className="size-4 text-muted-foreground" />
              {label}
            </span>
            <div className="flex flex-1 gap-2">
              <Select value={bill?.policy ?? "included"} onValueChange={next => onChange(setRoomBillPolicy(value, paymentType, next as RoomBillPolicy))}>
                <SelectTrigger variant="pill" className="flex-1" aria-label={t("policyFor", {
              utility: label
            })}>
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  {ROOM_BILL_POLICIES.map(policy => <SelectItem key={policy} value={policy}>
                      {t(`policies.${policy}`)}
                    </SelectItem>)}
                </SelectContent>
              </Select>
              {bill?.policy === "included_capped" && <Input type="number" inputMode="decimal" min={0} size="sm" leading="€" containerClassName="w-28" placeholder={t("capPlaceholder")} aria-label={t("capFor", {
            utility: label
          })} aria-invalid={bill.cap == null} value={bill.cap ?? ""} onChange={e => onChange(setRoomBillCap(value, paymentType, e.target.value === "" ? null : Number(e.target.value)))} />}
            </div>
          </div>;
    })}
      {value.some(b => b.policy === "included_capped") && <p className="text-xs text-muted-foreground">{t("capHint")}</p>}
    </div>;
}